import React from 'react'

import { Container, Row, Col } from 'components/grid'

import ArticlePreviewCard, { ArticlePreviewCardProps } from './card'
import { item } from './list.module.scss'

interface ArticleNode {
  node: {
    id: string
    title: string
    category: ArticlePreviewCardProps['category']
    featureImage: ArticlePreviewCardProps['image']
    fields: {
      path: string
      excerpt: string
    }
  }
}

interface ArticlePreviewListProps {
  articleList: ArticleNode[]
}

const ArticlePreviewList = ({ articleList }: ArticlePreviewListProps) => (
  <Container>
    <Row>
      {articleList.map(
        ({
          node: {
            id,
            title,
            category,
            featureImage,
            fields: { path, excerpt },
          },
        }) => (
          <Col xs={12} md={6} lg={4} xl={6} key={id} className={item}>
            <ArticlePreviewCard
              title={title}
              path={path}
              category={category}
              excerpt={excerpt}
              image={featureImage}
            />
          </Col>
        )
      )}
    </Row>
  </Container>
)

export default ArticlePreviewList
